import { render, staticRenderFns } from "./Anexos.vue?vue&type=template&id=3210667e&scoped=true&"
import script from "./Anexos.vue?vue&type=script&lang=js&"
export * from "./Anexos.vue?vue&type=script&lang=js&"
import style0 from "./Anexos.vue?vue&type=style&index=0&id=3210667e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3210667e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3210667e')) {
      api.createRecord('3210667e', component.options)
    } else {
      api.reload('3210667e', component.options)
    }
    module.hot.accept("./Anexos.vue?vue&type=template&id=3210667e&scoped=true&", function () {
      api.rerender('3210667e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/plugins/Anexos.vue"
export default component.exports